import { FC } from 'react';
import clsx from 'clsx';
import { mergeTailwindClasses } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';

export const PASSWORD_VALIDATION_KEYS = {
  length: 'validation.password.minLength',
  uppercase: 'validation.password.uppercase',
  lowercase: 'validation.password.lowercase',
  number: 'validation.password.number',
  symbol: 'validation.password.symbol',
};

type Props = {
  errors: string[];
};

const PasswordValidationPoints: FC<Props> = ({ errors }) => {
  const { t } = useTranslation();

  return (
    <div>
      {Object.values(PASSWORD_VALIDATION_KEYS).map((key) => (
        <div
          key={key}
          className={mergeTailwindClasses(
            clsx('tw-text-success-100', {
              'tw-text-danger-100': errors.includes(key),
            }),
          )}
        >
          <span className="tw-text-md">&#x2022;</span> {t(key)}
        </div>
      ))}
    </div>
  );
};

export default PasswordValidationPoints;
